import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {
    UIUXIcon,
    CMSIcon,
    EcommerceIcon,
    LaravelIcon,
    WebPortIcon,
    ContentIcon,
} from "../../../app-constants";
import {Link} from 'gatsby';

const StackItem = [
    {
        icon: UIUXIcon,
        title: 'UI/UX Design',
        description: "At TekRevol, we excel in creating captivating user interfaces and exceptional user experiences. From comprehensive Information Architecture (IA) planning to meticulous wireframing and stunning visual design, we craft websites that not only look amazing but also provide an intuitive and delightful user journey. Elevate your online presence with our UI/UX design expertise.",
    },
    {
        icon: CMSIcon,
        title: 'Website Development with CMS',
        description: "Choose the right Content Management System (CMS) for your website's needs. TekRevol offers expert website development with popular CMS platforms such as WordPress, Drupal, and Webflow. Whether it's a dynamic blog, a corporate website, or an e-commerce platform, we tailor our CMS solutions to your specific requirements.",
    },
    {
        icon: EcommerceIcon,
        title: 'E-commerce Development',
        description: "Transform your business into a thriving online store with TekRevol's ecommerce development services. We specialize in creating web-based stores using Shopify, WooCommerce, or BigCommerce. Our solutions are designed to boost your online sales and provide a seamless shopping experience for your customers",
    },
    {
        icon: LaravelIcon,
        title: 'Laravel Web Development',
        description: 'Our expert Laravel developers use robust development methodologies to design and build web-based products and applications that meet industry standards and best practices. Through quality Laravel web application development, our experts remain dedicated to providing clients with scalable business solutions that help boost profits, customer experience, and productivity.',
    },
    {
        icon: WebPortIcon,
        title: 'Web App or Web Portal Development',
        description: "Take your business to the next level with TekRevol's custom Web App and Web Portal development. Whether you need an internal tool to streamline your operations or you're launching a Software as a Service (SaaS) product, our expert team can build web-based applications that cater to your unique requirements. Experience efficiency and innovation like never before.",
    },
    {
        icon: ContentIcon,
        title: 'Content Development',
        description: "Your website's content is the voice of your brand. TekRevol collaborates closely with your team to understand your messaging and build the perfect content strategy for your website. From engaging copy to captivating visuals, we ensure that your online presence effectively communicates your brand's story and values.",
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>TekRevol’s Website Design Services In NJ</h2>
                        <p className="impro_para">Are you looking for something more than just a custom website? A website that’s geared towards a specific purpose or niche? A website built on a certain platform? Don’t worry, we’ve got it all covered with our top-tier <Link to='https://www.tekrevol.com/web-development' rel='noopener' aria-label='TekRevol' rel='noopener'>website development services</Link>! As the best web design company in NJ, we can offer the following specialized website platforms:</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;